import { ComponentView } from "binder";
import { FileSelectorViewModel, IFileDownloader } from "./fileSelector-viewModel"

export class FileSelectorView extends ComponentView<FileSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-907E64B0-9B3B-406C-96BE-AC6F9A048E58"
    }
    loadHtml(): string {
        let element = require('./fileSelector.html').default;
        let style = require('./fileSelector.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set filename(v: string) { this._filename = v; } public get filename(): string { return this._filename;} private _filename: string;
    public set fileid(v: string) { this._fileid = v; } public get fileid(): string { return this._fileid;} private _fileid: string;
    public set filecontent(v: string) { this._filecontent = v; } public get filecontent(): string { return this._filecontent;} private _filecontent: string;
    public set isreadonly(v: boolean) { this._isreadonly = v; } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set downloader(v: IFileDownloader) { this._downloader = v; } public get downloader(): IFileDownloader { return this._downloader;} private _downloader: IFileDownloader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set candownload(v: boolean) { this._candownload = v; } public get candownload(): boolean { return this._candownload;} private _candownload: boolean;
    public set maxSize(v: number) { this._maxSize = v; } public get maxSize(): number { return this._maxSize;} private _maxSize: number;

    chooseFile(){
        this.dataContext.chooseFile();
    }
    download(){
        this.dataContext.download();
    }
}


